import React from 'react';
import { Modal, Button } from 'antd';
import './index.scss';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import { getIn18Text } from 'api';
const SuccessModal = ({ visible, onClose }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { className: "UpgradeMeansSuccessModal", width: 480, visible: visible, destroyOnClose: true, footer: [
                React.createElement(Button, { key: "submit", type: "primary", onClick: () => {
                        onClose();
                    } }, getIn18Text('ZHIDAOLE')),
            ], onCancel: () => onClose() },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "icon" },
                    React.createElement(ReadListIcons.UpgradeInfoReceiveSvg, null)),
                React.createElement("div", { className: "content" }, getIn18Text('ZILIAOYITIJIAO'))))));
};
export default SuccessModal;
